import React from 'react';

import s from './styles.module.scss';

interface IProps {
  page: number;
  pageSize: number;
  idx: number;
}

const NumberColumn: React.FC<IProps> = ({ page, pageSize, idx }) => {
  const itemIndexPrefix = (page - 1) * pageSize;

  return <span className={s.number}>{itemIndexPrefix + idx + 1}</span>;
};

export default NumberColumn;
